import styled from 'styled-components';

const ErrorText = styled.p`
  font-family: Bangers, cursive;
  color: ${({ theme }) => theme.colors.pink};
  font-size: 1em;
`;

export default ErrorText;
